import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VParallax,{attrs:{"dark":"","src":_vm.imgSrc,"height":"300"}},[_c(VOverlay,{staticClass:"ma-0 pa-0",attrs:{"absolute":"","opacity":"0.3"}},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h1',{class:[_vm.$vuetify.breakpoint.mdAndUp ? 'display-4' : 'display-2']},[_vm._v(" "+_vm._s(_vm.title)+" ")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }